import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter"
export default class extends Controller {
  static targets = ["count", "input", "select", "header"]
  static outlets = ["sidebar"]

  connect() {
    if (this.hasSelectTarget) {
      this.updateSelectCount()
    }
    if (this.inputTargets.length > 0) {
      this.updateInputCount()
    }
  }

  updateInputCount() {
    const count = this.inputTargets.filter((input) => input.value !== "").length
    this.countTarget.textContent = count > 0 ? ` (${count})` : ""
    this.updateHeaderBold(count)
    this.notifySidebarOfChange()
  }

  updateSelectCount() {
    const selectedOptions = Array.from(this.selectTarget.selectedOptions)
    const count = selectedOptions.length
    this.countTarget.textContent = count > 0 ? ` (${count})` : ""
    this.updateHeaderBold(count)
    this.notifySidebarOfChange()
  }

  updateHeaderBold(count) {
    if (!this.hasHeaderTarget) return

    if (count > 0) {
      this.headerTarget.classList.add("font-bold")
    } else {
      this.headerTarget.classList.remove("font-bold")
    }
  }

  notifySidebarOfChange() {
    if (this.hasSidebarOutlet) {
      this.sidebarOutlet.updateTotalCount()
    }
  }
}
